import React, { useEffect, useState } from 'react';

/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { Knobs } from '../../Docs/DocTypes';
import { TagEditField, IChangeArgs } from '@tag/tag-components-react-v2';
import { camelCaseToDash } from '../../Docs/DocsUtils';
import { KnobValues, getWindowWidth } from './KnobsUtils';

type HTMLKnobsProps = {
  knobs: Knobs;
  knobValues: KnobValues;
  onChange: (knobValues: KnobValues) => void;
  camelCaseLabels: boolean;
};
export const KnobsPanel = (props: HTMLKnobsProps) => {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth());

  useEffect(() => {
    const handleResize = () => setWindowWidth(getWindowWidth());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleChange = (e: CustomEvent<IChangeArgs>) => {
    props.onChange({ ...props.knobValues, [e.detail.name]: e.detail.value });
  };

  const styles = makeStyles();

  return (
    <div css={styles.root}>
      {Object.keys(props.knobs).map(key => (
        <div key={key} css={styles.container(windowWidth)}>
          <div
            css={
              props.knobs[key].editor === 'checkbox'
                ? styles.checkboxWrapper(windowWidth)
                : styles.editorFullWidth
            }
          >
            <TagEditField
              name={key}
              label={props.camelCaseLabels ? key : camelCaseToDash(key)}
              labelPosition={windowWidth > 768 ? 'left' : 'top'}
              editor={props.knobs[key].editor}
              value={props.knobValues[key]}
              options={
                props.knobs[key].editorOptions &&
                props.knobs[key].editorOptions!.map(option => ({
                  label: option,
                  value: option,
                }))
              }
              rows={3}
              editorStyle={{ border: '1px solid #b1b8bf', borderRadius: '2px', flexGrow: 1 }}
              onValueChange={handleChange}
              css={props.knobs[key].editor !== 'checkbox' ? styles.editorFullWidth : ''}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

const makeStyles = () => {
  return {
    root: css`
      margin-bottom: 20px;
    `,
    container: (windowWidth: number) => css`
      margin-bottom: ${windowWidth > 768 ? '5px' : '10px'};
      display: flex;
      align-items: center;
    `,
    editorFullWidth: css`
      width: 100%;
    `,

    checkboxWrapper: (windowWidth: number) => css`
      margin-left: ${windowWidth > 768 ? '125px' : '0px'};
    `,
    checkboxEditor: (windowWidth: number) => css`
      margin-left: ${windowWidth > 768 ? '125px' : '0px'};
    `,
  };
};
